import React from 'react';

import PrimaryButton from '../../_common/button';
import { CategoryContainer } from '../../_common/category/CategoryContainer';
import {
  ActionType,
  Flow,
  FormState,
  useBookingContext,
} from '../../_common/context/BookingContext';
import { useCategoryContext } from '../../_common/context/CategoryContext';
import { CenteredSpinner, SpinnerSizes } from '../../_common/Spinner';
import { Heading4, InfoText } from '../../_common/Typography';
import useFeatureFlag from '../../_common/utils/hooks/useFeatureFlag';
import { useScopedTranslation } from '../../_common/utils/hooks/useScopedTranslation';
import useUpdateTranslations, {
  Module,
} from '../../_common/utils/hooks/useUpdateTranslations';
import { ApplicationHeader } from '../../components/ApplicationHeader/Header';

import CustomerForm from './customerForm';
import MainForm from './mainForm';

function Booking() {
  const {
    categories,
    category,
    categorySelectionEnabled,
    isLoading,
    onChangeCategory,
  } = useCategoryContext();
  const [{ customerFormState, flow }, dispatch] = useBookingContext();
  const { t } = useScopedTranslation();
  const isMaintenanceMode = useFeatureFlag('maintenance.enabled');

  function showCustomerForm() {
    dispatch({
      type: ActionType.SET_CUSTOMER_FORM_STATE,
      payload: FormState.EXPANDED,
    });
  }

  useUpdateTranslations(
    flow === Flow.SELF_SERVICE ? Module.SELF_SERVICE : Module.BOOKING,
  );

  if (isMaintenanceMode) {
    return (
      <div className="flex w-full h-full">
        <div className="m-auto">
          <div className="m-auto text-center">
            <Heading4>{t('common:maintenance_mode.title')}</Heading4>
            <InfoText>{t('common:maintenance_mode.text')}</InfoText>
          </div>
        </div>
      </div>
    );
  }

  if (isLoading) {
    return <CenteredSpinner size={SpinnerSizes.LARGE} />;
  }

  if (category === undefined && categorySelectionEnabled) {
    return (
      <CategoryContainer categories={categories} onSelect={onChangeCategory} />
    );
  }

  return (
    <div className="flex flex-row-reverse w-full h-full">
      <div
        className={`bg-white flex-1 overflow-y-auto ${
          customerFormState === FormState.COLLAPSED ? 'w-full' : 'w-0'
        }`}
      >
        <div className="px-3 py-4 lg:px-6 lg:py-6">
          {customerFormState === FormState.COLLAPSED && (
            <div className="flex justify-end pb-4 w-full lg:hidden">
              <PrimaryButton
                onClick={showCustomerForm}
                style={{ width: 'auto' }}
              >
                {t('main_form.buttons.customer_form')}
              </PrimaryButton>
            </div>
          )}
          <MainForm />
        </div>
      </div>
      <CustomerForm />
    </div>
  );
}

function BookingContainer() {
  return (
    <div className="flex flex-col h-screen overflow-hidden">
      <div className="flex-shrink-0">
        <ApplicationHeader />
      </div>
      <div className="flex-1 min-h-0 overflow-hidden">
        <Booking />
      </div>
    </div>
  );
}

export default BookingContainer;
